module.exports = __webpack_public_path__ + "static/media/entertain-easy-rider.883ca981.mp4";